import { getApiGalaxyServer } from 'services';

export interface TeamTagsLookupResponse {
  tags: Record<string, number>;
  total: number;
}

export const getTeamTagsLookupApi = ({ token, config = {} }: BaseApiParams<void>) => {
  return getApiGalaxyServer<TeamTagsLookupResponse>(`/lookup/teams/tags`, config, token);
};
